export const mapDrawbackResponse = (data) => {
  if (!data) return {};
  return {
    exportProductId: data.exportProductId ?? null,
    isExportProductDrawbackThisDBKItem: data.isExportProductDrawbackThisDBKItem ?? false,
    exportProductDrawbackDbkSrNoId: data.exportProductDrawbackDbkSrNoId ?? null,
    exportProductDrawbackDbkSrNo: data.exportProductDrawbackDbkSrNo !== 'N/A' ? data.exportProductDrawbackDbkSrNo : null,
    exportProductDrawbackFOBValue: `${data.exportProductDrawbackFOBValue ?? 0} ${data.exportProductDrawbackFOBValueUnit ?? null}`,
    exportProductDrawbackQuantity: data.exportProductDrawbackQuantity ?? 0,
    exportProductDrawbackQuantityValueId: data.exportProductDrawbackQuantityValueId ?? null,
    exportProductDrawbackQuantityValue: data.exportProductDrawbackQuantityValue ?? null,
    exportProductDrawbackDbkUnder: data.exportProductDrawbackDbkUnder ?? null,
    exportProductDrawbackDBKDesc: data.exportProductDrawbackDBKDesc ?? null,
    exportProductDrawbackDBKRate: data.exportProductDrawbackDBKRate,
    exportProductDrawbackDBKCap: data.exportProductDrawbackDBKCap,
    exportProductDrawbackDKAmt: data.exportProductDrawbackDKAmt ?? null,

    // ✅ Derived field as numeric sum
    exportProductDrawbackDKAmtDesc: `${data.exportProductDrawbackDBKRate} of FOB Value`,

    exportProductDrawbackStatus: data.exportProductDrawbackStatus ?? "",
  };
};
